module.exports = __webpack_public_path__ + "media/images/athletes/527-3f263a26764419450a281b12b855fc1b.png";